import React from 'react';

import './FooterOverlay.css';

const FooterOverlay = () => (
  <div className='app__footerOverlay app__bg'>
    <div className="app__footerOverlay-black" />
    <div className="app__footerOverlay-img" />
  </div>
);

export default FooterOverlay;
